<template>
  <div>
    <!-- element-ui -->
    <el-container>
      <el-header height='80px'>
        <div class="header">
          <!-- del -->
          <img style="height: 80px" class="bg" src="../../../static/images/header.png" alt="" v-if="!userInfo.school_logo">
          <template v-else>
            <img style="height: 80px" class="bg" src="../../../static/images/shheader.jpg" alt="">
            <img style="height: 74px" class="logoss" :src="GLOBAL.BASE_URL+userInfo.school_logo" alt="">
          </template>
          <!-- <img  style="height: 80px" class="bg"  src="../../../static/images/shheader.jpg" alt=""> 
                 <img  style="height: 64px" class="logoss"  src="../../../static/images/shlogo.png" alt="">  -->
          <!-- <div class="bj"></div> -->
          <div style=" position: relative;">
            <!-- <div class="nav-left">
            <router-link to="/course"><img  style="height: 50px"  src="../../../static/images/logo.png" alt=""></router-link>
          </div> -->
            <!-- <div class="nav-center">
            <ul>
              <li v-for='(list,index) in headerList' :key='list.id'>
                <router-link :to='{name:list.name}'>
                  {{list.title}}
                </router-link>
              </li>
            </ul>
          </div> -->

            <!-- <el-dropdown> -->
            <div class="nav-right " v-if='this.$cookies.get("token")' @mouseenter='enterHandler' @mouseleave='leaveHandler'>
              <span class='el-dropdown-link'>学习中心</span>
              <!-- <span class='el-dropdown-link'  v-else>{{userInfo.school_name}}</span> -->
              <span class="user">{{userInfo.realname}}</span>
              <img :src="GLOBAL.BASE_URL+userInfo.head_img" alt="" v-if="userInfo.head_img">
              <img src="../../../static/images/defaultimg.png" alt="" v-else>
              <ul class="my_account" v-show='isShow'>
                 <!-- <li @click='gomessage'>
                  消息中心
                </li> -->
                <li @click='practiceList'>
                  训练项目
                </li>
                <li @click='practiceHistory'>
                  成绩中心
                </li>
                <!-- <li @click='goap'>
                  考试安排
                </li> -->
                <li @click='goexam'>
                  我的考试
                </li>
                <li @click='gotask'>
                  我的作业
                </li>
                 <li @click='gotheory'>
                  理论考试
                </li>
                <li @click='myInfo'>
                  个人中心
                </li>
                <!-- <li @click='changePassword'>
                  修改密码
                </li> -->
                <li @click='logout'>
                  退出
                </li>
              </ul>
            </div>
            <!-- </el-dropdown> -->
            <div class="nav-right" v-else>
              <i class="el-icon-user"></i>
              <span @click="goLogin">登录</span>
              <!--          &nbsp;| &nbsp;-->
              <!--          <span>注册</span>-->

            </div>
          </div>
        </div>
      </el-header>
    </el-container>
    <div style="min-height: 750px">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>

    </div>
    <div class="login-footer">
      <p> 技术支持单位：北京众绘虚拟现实技术研究院有限公司 联系电话：01060496324</p>
      <!-- <p @click="gohref" class="hrefs">京ICP备18051304号-2</p> -->
      <p @click="gohref" class="hrefs">京ICP备18051304号-3</p>
    </div>
  </div>

</template>

<script>
export default {
  name: 'LuffyHeader',
  data() {
    return {
      headerList: [
        // {id: '1', name: 'Home', title: '首页'},
        // {id: '2', name: 'Course', title: '实验列表'},
        // {id:'3',name:'LightCourse',title:'轻课'},
        // {id:'4',name:'Micro',title:'学位课程'}
      ],
      isShow: false,
      userInfo: []
    }
  },
  methods: {

    gohref() {
      window.open("http://www.beian.miit.gov.cn");
    },
    goap() {
      this.$router.push({
        name: 'examarrangement'
      })
    },
    gotheory(){
this.$router.push({
        name: 'theorylist'
      })
    },
    goexam() {
      this.$router.push({
        name: 'examination'
      })
    },
    gomessage(){
 this.$router.push({
        name: 'messcenter'
      })
    },
    gotask() {
      this.$router.push({
        name: 'mytask'
      })
    },
    myInfo() {
      this.$router.push({
        name: 'myInfo'
      })
    },
    practiceList() {
      this.$router.push({
        name: 'practiceList'
      })
    },
    practiceHistory() {
      this.$router.push({
        name: 'practices'
      })
    },
    changePassword() {
      this.$router.push({
        name: 'changePassword'
      })
    },
    logout() {
      this.$cookies.remove('token');
      this.$store.dispatch('SetUserInfo', null);
      this.$router.push({
        name: 'Login'
      })
    },
    goLogin() {
      this.$router.push({ name: 'Login' })
    },
    enterHandler() {
      this.isShow = true;
    },
    leaveHandler() {
      this.isShow = false;
    },
    getUser() {
      if (this.$cookies.get("token")) {
        this.$http.getUserInfo().then(res => {
          this.userInfo = res.data
          this.$store.dispatch("SetUserInfo", res.data);
       //   console.log(this.userInfo)
        })
      }
    }
  },
  created() {
    this.getUser()
  },

};
</script>

<style lang="css" scoped>
.login-footer {
  width: 100%;
  height: 50px;
  /* line-height: 50px; */
  text-align: center;
  font-size: 14px;
  color: #4e546c;
  background: #fff;
  /* position: fixed;
    bottom:0;
    z-index: 10; */
  /* background: transparent; */
  p {
    margin-top: 0;
  }
}
.hrefs {
  cursor: pointer;
}
.el-header {
  border-bottom: #c9c9c9;
  box-shadow: 0 0.5px 0.5px 0 #c9c9c9;
  background: #085da8;
  color: white;
  padding: 0;
}

.header {
  width: 1200px;
  width: 100%;
  height: 80px;
  line-height: 80px;
  margin: 0 auto;
  position: relative;
}

.nav-left {
  float: left;
  margin-top: 10px;
}
.bg {
  width: 100%;
  position: absolute;
}
.logoss {
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
  position: absolute;
}
.nav-center {
  float: left;
  margin-left: 100px;
  width: ;
}

.nav-center ul {
  overflow: hidden;
}

.nav-center ul li {
  float: left;
  margin: 0 5px;
  /*width: 100px;*/
  padding: 0 20px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.nav-center ul li a {
  color: #4a4a4a;
  width: 100%;
  height: 60px;
  display: inline-block;
}

.nav-center ul li a:hover {
  color: #b3b3b3;
}

.nav-center ul li a.is-active {
  color: #4a4a4a;
  border-bottom: 4px solid #ffc210;
}

.nav-right {
  float: right;
  position: relative;
  z-index: 100;
  margin-right: 20px;
}

.nav-right span {
  cursor: pointer;
}

.nav-right .user {
  margin-left: 15px;
}

.nav-right img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
}

.nav-right ul {
  position: absolute;
  width: 221px;
  z-index: 100;
  font-size: 12px;
  top: 80px;
  background: #fff;
  border-top: 2px solid #d0d0d0;
  box-shadow: 0 2px 4px 0 #e8e8e8;
}

.nav-right ul li {
  height: 40px;
  color: #4a4a4a;
  padding-left: 30px;
  padding-right: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s linear;
}

.nav-right ul li span.msg {
  margin-left: -80px;
  color: red;
}

.nav-right ul li span.count {
  margin-left: -100px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/LuffyHeader.vue